import { combineReducers } from "redux";
import filterReducer from "./filterReducer";
import languageReducer from "./languageReducer";
import settingsReducer from "./settingsReducer";
import codeListReducer from "./codeListReducer";
import screenSaverReducer from "./screenSaverReducer";
import mallEnviromentReducer from "./mallEnviromentReducer";
import facilities from './facilityReducer'

const rootReducer = combineReducers({
  filter: filterReducer,
  language: languageReducer,
  settings: settingsReducer,
  onScreenSaverMode: screenSaverReducer,
  // Logos with their cooresponding coordinates
  logosCoors: codeListReducer,
  titleCoors: codeListReducer,
  mallEnviromentData: mallEnviromentReducer,
  facilities:  facilities
});

export default rootReducer;